<template>
  <!-- 发布活动页面 -->
  <div class="page-container">
    <!-- 页面头部 -->
    <div>
      <div class="page-card__header">
        <span style="padding-right: 20px"> 发布活动</span>
      </div>
    </div>
    <div style="padding: 20px">
      <el-form ref="form" :model="form" :rules="rules" label-width="80px" >

        <!-- 转发封面预览与上传 -->
        <el-image v-if="form.logo !== ''"
                  :src="imgUrl+form.logo" style="width: 200px;height: 160px"></el-image>
        <el-form-item prop="img" label-width="0px">
          <el-upload
            class="avatar-uploader"
            :action="imagesrc"
            :show-file-list="false"
            :on-success="handleAvatarSuccess"
            :headers="headers"
            :before-upload="beforeAvatarUpload">
            <el-button size="small" type="primary" round>点击上传转发封面</el-button>
            <div slot="tip" class="el-upload__tip">最佳展示尺寸：5:4，建议 500 x 400 像素，该图片将作为活动分享转发时的封面图</div>
          </el-upload>
        </el-form-item>

        <!-- 基本信息表单 -->
        <el-form-item label="标题" prop="title">
          <el-input v-model="form.title"></el-input>
        </el-form-item>
        <el-form-item label="描述" prop="desc">
          <el-input v-model="form.desc"></el-input>
        </el-form-item>
        <!-- 嘉宾设置：单个嘉宾 / 多嘉宾 二选一 -->
        <el-form-item label="嘉宾设置" prop="guestMode">
          <el-radio-group v-model="form.guestMode">
            <el-radio-button label="single">单个演讲嘉宾</el-radio-button>
            <el-radio-button label="multi">多位演讲嘉宾</el-radio-button>
          </el-radio-group>
          <span class="guest-mode-tip">两种方式二选一：填了多嘉宾后，单个嘉宾的姓名 / 职位 / 公司名会被清空</span>
        </el-form-item>

        <!-- 单个嘉宾 -->
        <template v-if="form.guestMode === 'single'">
          <el-form-item label="演讲嘉宾" prop="host">
            <el-input v-model="form.host"></el-input>
          </el-form-item>
          <el-form-item label="职位" prop="position">
            <el-input v-model="form.position"></el-input>
          </el-form-item>
          <el-form-item label="公司名" prop="company">
            <el-input v-model="form.company"></el-input>
          </el-form-item>
        </template>

        <!-- 多位嘉宾：guest 存 JSON 数组，字段与小程序端一致 -->
        <el-form-item v-else label="演讲嘉宾" prop="guestList">
          <div class="guest-editor">
            <div class="guest-row" v-for="(g, i) in form.guestList" :key="i">
              <div class="guest-row__head">
                <span class="guest-row__idx">嘉宾 {{ i + 1 }}</span>
                <el-button type="text" class="action-btn--danger" @click="removeGuest(i)">删除</el-button>
              </div>
              <el-row :gutter="12">
                <el-col :span="12">
                  <el-input v-model="g.topic" placeholder="主讲主题（选填）"></el-input>
                </el-col>
                <el-col :span="12">
                  <el-input v-model="g.host" placeholder="嘉宾姓名（必填）"></el-input>
                </el-col>
                <el-col :span="12">
                  <el-input v-model="g.company" placeholder="单位（选填）"></el-input>
                </el-col>
                <el-col :span="12">
                  <el-input v-model="g.position" placeholder="职位（选填）"></el-input>
                </el-col>
              </el-row>
            </div>
            <el-button size="small" icon="el-icon-plus" @click="addGuest">添加一位嘉宾</el-button>
            <p class="guest-editor__tip">嘉宾姓名必填；单位与职位会拼成「单位职位 姓名」展示，与小程序一致</p>
          </div>
        </el-form-item>

        <el-form-item label="举办方式" prop="type" style="text-align: left">
          <el-radio-group v-model="form.type">
            <el-radio label="线上">线上</el-radio>
            <el-radio label="线下">线下</el-radio>
          </el-radio-group>
        </el-form-item>

        <el-form-item label="时间" prop="start_time">
          <el-col :span="5">
            <el-form-item label="" prop="start_time">
              <el-date-picker
                type="datetime"
                placeholder="选择开课日期"
                v-model="form.start_time"
                style="width: 100%"
                value-format="yyyy-MM-dd HH:mm:ss"
              ></el-date-picker>
            </el-form-item>
          </el-col>

          <el-col class="line" :span="2">-</el-col>

          <el-col :span="5">
            <el-form-item label="" prop="end_time">
              <el-date-picker
                type="datetime"
                placeholder="选择结课日期"
                v-model="form.end_time"
                style="width: 100%"
                value-format="yyyy-MM-dd HH:mm:ss"
              ></el-date-picker>
            </el-form-item>
          </el-col>
        </el-form-item>

        <el-form-item label="地址" prop="address">
          <el-input v-model="form.address"></el-input>
        </el-form-item>

        <!-- 活动内容编辑 -->
        <el-form-item label="内容" prop="info">
          <tiny-editor
            v-model="form.info"
            :init="init"
            id="textarea"
          ></tiny-editor>
        </el-form-item>

        <!-- <el-form-item label="内容" prop="info">
          <vue-html5-editor
            :content="form.info"
            :height="300"
            v-model="form.info"
            :show-module-name="showModuleName"
            @change="updateData"
            ref="editor"
          ></vue-html5-editor>
        </el-form-item> -->

        <!-- 提交按钮区域 -->
        <el-form-item>
          <el-col :span="12" style="text-align: right; padding-right: 10px">
            <el-button
              type="primary"
              round
              size="small"
              @click="onBaseSubmit('form')"
            >发布活动
            </el-button
            >
          </el-col>
          <el-col :span="12" style="text-align: left; padding-left: 10px">
            <el-button type="danger" round size="small" @click="back"
            >取消返回
            </el-button
            >
          </el-col>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>
<script>
  import editor from "@tinymce/tinymce-vue";
  import {VueEditor} from "vue2-editor";
  import api from "../../utils/api";

  /**
   * 一行空嘉宾。
   * guest 字段提交的是 JSON 字符串：[{ topic, host, company, position }]，
   * 与小程序端 pages/activity/detail.js 的 parseGuest 解析格式保持一致。
   */
  var EMPTY_GUEST = function () {
    return { topic: "", host: "", company: "", position: "" };
  };

  export default {
    components: {
      VueEditor,
      "tiny-editor": editor,
    },
    name: "addActivity",
    data() {
      // 单个嘉宾（姓名 / 职位 / 公司名）与多嘉宾是二选一，
      // 多嘉宾模式下这三个字段被隐藏，需要跳过必填校验
      var singleGuestRule = (message) => (rule, value, callback) => {
        if (this.form.guestMode === "multi") {
          callback();
          return;
        }
        if (!value) {
          callback(new Error(message));
          return;
        }
        callback();
      };
      return {
        init: {
          // 配置信息
          selector: "#textarea",
          height: 550,
          language_url: "/static/tinymce/langs/zh-Hans.js", // 中文包的存放路径
          language: "zh-Hans",
          // skin_url: 'static/js/tinymce/skins/ui/oxide-dark',
          // content_css: 'static/js/tinymce/skins/content/dark/content.min.css',
          menubar: true,
          // plugins: "image",
          image_dimensions: false,
          images_upload_url:
            "https://cloudexhibition.chinafastenerinfo.com/api/admin/uploadfile/news/",
          images_upload_base_path:
            "https://cloudexhibition.oss-cn-shenzhen.aliyuncs.com/news/",

          plugins: [
            "advlist autolink lists link image imagetools charmap print preview anchor textcolor imageupload",
            "searchreplace visualblocks code fullscreen ",
            "insertdatetime media table contextmenu paste code help wordcount",
          ],
          toolbar:
            "preview link code insertdatetime  charmap | media  image | undo redo |  formatselect | bold italic backcolor  | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent  | removeformat | help",
          automatic_uploads: true,
          images_upload_handler: function (blobInfo, succFun, failFun) {
            var xhr, formData;
            var file = blobInfo.blob(); //转化为易于理解的file对象
            xhr = new XMLHttpRequest();
            xhr.withCredentials = true;
            xhr.open(
              "POST",
              "https://cloudexhibition.chinafastenerinfo.com/api/admin/uploadfile/news/"
            );

            // 设置请求头
            xhr.setRequestHeader(
              "Authorization",
              "JWT " + localStorage.getItem("adminToken")
            );
            xhr.setRequestHeader("XMLHttpRequest", "HeaderValue");

            xhr.onload = function () {
              var json;
              if (xhr.status != 200) {
                failFun("HTTP Error: " + xhr.status);
                return;
              }
              json = JSON.parse(xhr.responseText);
              // if (!json || typeof json.location != "string") {
              //   failFun("Invalid JSON: " + xhr.responseText);
              //   return;
              // }
              succFun(
                "https://cloudexhibition.oss-cn-shenzhen.aliyuncs.com/news/" +
                json.filename
              );
            };
            formData = new FormData();
            formData.append("file", file, file.name); //此处与源文档不一样
            xhr.send(formData);
          },
        },
        headers: {"Authorization": "JWT " + localStorage.getItem('adminToken')},
        imagesrc: this.baseUrl + "/admin/uploadfile/activity/",
        imgUrl: 'https://cloudexhibition.oss-cn-shenzhen.aliyuncs.com/activity/',
        showModuleName: true,
        form: {
          logo: '',
          title: "",
          type: "",
          company: '',
          position: '',
          address: "",
          desc: "",
          host: "",
          info: "",
          start_time: "",
          end_time: "",
          /** single = 单个嘉宾，multi = 多嘉宾（提交时序列化成 guest） */
          guestMode: "single",
          guestList: [EMPTY_GUEST()],
        },
        newimgUrl: "https://cloudexhibition.oss-cn-shenzhen.aliyuncs.com/news/",


        rules: {
          title: [{required: true, message: "请输入活动名称", trigger: "blur"}],
          type: [{required: true, message: "请选择活动类型", trigger: "blur"}],
          address: [
            {required: true, message: "请输入活动地址", trigger: "blur"},
          ],
          company: [{ trigger: "blur", validator: singleGuestRule("请输入公司名") }],
          position: [{ trigger: "blur", validator: singleGuestRule("请输入职位") }],
          desc: [{required: true, message: "请输入描述", trigger: "blur"}],
          host: [{ trigger: "blur", validator: singleGuestRule("请输入演讲嘉宾") }],
          guestList: [{
            trigger: "change",
            validator: (rule, value, callback) => {
              if (this.form.guestMode !== "multi") {
                callback();
                return;
              }
              var list = (this.form.guestList || []).filter(function (g) {
                return (g.topic || g.host || g.company || g.position || "").trim();
              });
              if (!list.length) {
                callback(new Error("请至少添加一位演讲嘉宾"));
                return;
              }
              for (var i = 0; i < list.length; i++) {
                if (!(list[i].host || "").trim()) {
                  callback(new Error("第 " + (i + 1) + " 位嘉宾请填写姓名"));
                  return;
                }
              }
              callback();
            },
          }],
          info: [{required: true, message: "请输入活动内容", trigger: "blur"}],
          start_time: [
            {required: true, message: "请选择开始时间", trigger: "blur"},
          ],
          end_time: [
            {required: true, message: "请选择结束时间", trigger: "blur"},
          ],
        },
      };
    },
    methods: {
      // 提交发布活动表单
      onBaseSubmit(formname) {
        this.$refs[formname].validate((valid) => {
          if (valid) {
            let url = this.baseUrl + "/admin/activitys/";
            let isMulti = this.form.guestMode === "multi";
            let guests = isMulti ? this.buildGuestPayload() : [];
            api
              .postData(url, {
                title: this.form.title,
                type: this.form.type,
                address: this.form.address,
                desc: this.form.desc,
                logo:this.form.logo,
                // 两种填法二选一：多嘉宾模式把单嘉宾三个字段清空，避免两边数据打架
                company: isMulti ? "" : this.form.company,
                position: isMulti ? "" : this.form.position,
                host: isMulti ? "" : this.form.host,
                guest: guests.length ? JSON.stringify(guests) : "",
                info: this.form.info,
                start_time: this.form.start_time,
                end_time: this.form.end_time,
                share: 0,
                view: 0,
                praise: 0,
              })
              .then((res) => {
                this.$message({
                  message: "添加活动成功",
                  type: "success",
                });
                this.$router.push({name: "admin_activityList"});
              });
          }
        });
      },

      // 追加一位空嘉宾
      addGuest() {
        this.form.guestList.push(EMPTY_GUEST());
      },

      // 删除第 index 位嘉宾，至少保留一行
      removeGuest(index) {
        this.form.guestList.splice(index, 1);
        if (!this.form.guestList.length) {
          this.form.guestList.push(EMPTY_GUEST());
        }
      },

      // 提交前序列化多嘉宾，剔除整行空白的占位行
      buildGuestPayload() {
        return (this.form.guestList || []).reduce(function (acc, g) {
          var row = {
            topic: (g.topic || "").trim(),
            host: (g.host || "").trim(),
            company: (g.company || "").trim(),
            position: (g.position || "").trim(),
          };
          if (row.topic || row.host || row.company || row.position) {
            acc.push(row);
          }
          return acc;
        }, []);
      },

      // 更新富文本编辑器内容
      updateData: function (data) {
        // sync content to component
        this.form.info = data;
      },
      // 富文本编辑器上传图片回调函数
      handleImageAdded(file, Editor, cursorLocation, resetUploader) {
        let url = this.baseUrl + "/admin/uploadfile/news/";
        const formData = new FormData();
        formData.append("file", file);
        api.postData(url, formData).then((res) => {
          Editor.insertEmbed(
            cursorLocation,
            "image",
            this.newimgUrl + res.filename
          );
          resetUploader();
        });
      },
      // 返回活动列表页
      back() {
        this.$router.push({name: "admin_activityList"});
      },

      // 图片上传成功回调
      handleAvatarSuccess(res, file) {

        let imageUrl = URL.createObjectURL(file.raw);
        this.form.logo = res.filename;

      },
      // 图片上传前校验
      beforeAvatarUpload(file) {
      }
    },
  };
</script>

<style scoped>
  /* ===== 多嘉宾 ===== */
  .guest-mode-tip {
    margin-left: 12px;
    font-size: 12px;
    color: var(--text-muted);
  }

  .guest-editor {
    width: 100%;
  }

  .guest-row {
    padding: 12px 12px 2px;
    background: var(--border-color-light);
    border: 1px solid var(--border-color-light);
    border-radius: var(--radius-md);
  }

  .guest-row + .guest-row {
    margin-top: 10px;
  }

  .guest-row__head {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 10px;
  }

  .guest-row__idx {
    font-size: 13px;
    font-weight: 600;
    color: var(--text-secondary);
  }

  .guest-row .el-col {
    margin-bottom: 10px;
  }

  .guest-editor__tip {
    margin: 8px 0 0;
    font-size: 12px;
    line-height: 20px;
    color: var(--text-muted);
  }
</style>



// WEBPACK FOOTER //
// src/components/admin/addActivity.vue